import React from "react";
import { useI18n } from "../i18n/I18nContext";

const CONTROLLER = {
  name: "Demetrio Campolo",
  street: "Mintarder Weg 29",
  city: "40472 Düsseldorf",
  email: "info@webmabw.com",
};

const CONTENT = {
  it: {
    title: "Informativa sulla privacy",
    sub: "Trattamento dei dati personali secondo il GDPR (UE 2016/679).",
    last_update: "Ultimo aggiornamento: febbraio 2026",
    sections: [
      {
        h: "1. Titolare del trattamento",
        p: `${CONTROLLER.name}, ${CONTROLLER.street}, ${CONTROLLER.city} (Germania). Email: ${CONTROLLER.email}.`,
      },
      {
        h: "2. Dati raccolti",
        p: "Quando ti registri raccogliamo: nome, cognome, email, città di residenza, password (memorizzata in forma crittografata, mai in chiaro). Quando pubblichi una richiesta o invii un messaggio, il contenuto viene conservato nel nostro database. Per la mappa, geocodifichiamo la città indicata in latitudine/longitudine approssimative (non un indirizzo preciso).",
      },
      {
        h: "3. Finalità del trattamento",
        p: "I dati sono trattati esclusivamente per: (a) consentire la registrazione e l'autenticazione; (b) collegare le persone che chiedono aiuto a quelle che lo offrono; (c) inviare notifiche email su richieste, offerte e messaggi; (d) prevenire abusi (es. blocco temporaneo dopo molti tentativi di login falliti).",
      },
      {
        h: "4. Base giuridica",
        p: "Il trattamento si fonda sull'art. 6 par. 1 lett. b GDPR (esecuzione di un contratto/servizio richiesto dall'utente) e sull'art. 6 par. 1 lett. f GDPR (legittimo interesse a mantenere il servizio sicuro).",
      },
      {
        h: "5. Cookie e tecnologie simili",
        p: "Utilizziamo un solo cookie tecnico (httpOnly + Secure + SameSite=None) per mantenere la sessione di accesso. Non utilizziamo cookie di profilazione, di analisi, di pubblicità o di terze parti pubblicitarie.",
      },
      {
        h: "6. Servizi di terzi",
        p: "Per il funzionamento del sito utilizziamo: Resend (invio email transazionali, server in UE/USA con clausole contrattuali standard UE), OpenStreetMap/Nominatim (visualizzazione mappe e geocodifica città — server in UE), GoFundMe (link esterno per donazioni libere, non condividiamo dati con loro). Non utilizziamo Google Analytics, Facebook Pixel o sistemi simili di tracciamento.",
      },
      {
        h: "7. Conservazione dei dati",
        p: "I dati sono conservati finché il tuo account è attivo. Puoi richiedere in qualsiasi momento la cancellazione del tuo account scrivendoci via email. I dati relativi a richieste e aiuti completati possono essere conservati in forma anonimizzata (senza il tuo nome) per il muro pubblico degli aiuti.",
      },
      {
        h: "8. I tuoi diritti",
        p: "Ai sensi degli artt. 15-22 GDPR hai diritto a: accesso ai tuoi dati, rettifica, cancellazione, limitazione del trattamento, portabilità, opposizione. Per esercitare questi diritti scrivici a " + CONTROLLER.email + ".",
      },
      {
        h: "9. Diritto di reclamo",
        p: "Hai diritto di proporre reclamo all'autorità di controllo competente. In Germania (Renania Settentrionale-Vestfalia): Landesbeauftragte für Datenschutz und Informationsfreiheit NRW, https://www.ldi.nrw.de.",
      },
      {
        h: "10. Sicurezza",
        p: "Le password sono memorizzate con algoritmo di hashing (bcrypt). Il traffico tra il tuo browser e il sito è cifrato (HTTPS). Adottiamo misure tecniche e organizzative ragionevoli per proteggere i tuoi dati.",
      },
    ],
  },
  en: {
    title: "Privacy policy",
    sub: "Processing of personal data under GDPR (EU 2016/679).",
    last_update: "Last updated: February 2026",
    sections: [
      {
        h: "1. Data controller",
        p: `${CONTROLLER.name}, ${CONTROLLER.street}, ${CONTROLLER.city} (Germany). Email: ${CONTROLLER.email}.`,
      },
      {
        h: "2. Data we collect",
        p: "When you register we collect: first name, last name, email, city of residence, password (stored encrypted, never in plain text). When you publish a request or send a message, the content is stored in our database. For the map, we geocode the city you provide into approximate latitude/longitude (not a precise address).",
      },
      {
        h: "3. Purpose of processing",
        p: "Data is processed solely to: (a) enable registration and authentication; (b) connect people asking for help with those offering it; (c) send email notifications about requests, offers and messages; (d) prevent abuse (e.g. temporary lockout after many failed login attempts).",
      },
      {
        h: "4. Legal basis",
        p: "Processing is based on Art. 6(1)(b) GDPR (performance of a contract/service requested by the user) and Art. 6(1)(f) GDPR (legitimate interest in keeping the service secure).",
      },
      {
        h: "5. Cookies and similar technologies",
        p: "We use only one technical cookie (httpOnly + Secure + SameSite=None) to maintain your login session. We do not use profiling, analytics, advertising or third-party advertising cookies.",
      },
      {
        h: "6. Third-party services",
        p: "To operate the site we use: Resend (transactional email delivery, servers in EU/US with EU Standard Contractual Clauses), OpenStreetMap/Nominatim (map display and city geocoding — EU servers), GoFundMe (external link for voluntary donations, we do not share data with them). We do not use Google Analytics, Facebook Pixel or similar tracking systems.",
      },
      {
        h: "7. Data retention",
        p: "Data is kept as long as your account is active. You may request deletion of your account at any time by emailing us. Data about completed requests and helps may be retained in anonymized form (without your name) for the public wall of good deeds.",
      },
      {
        h: "8. Your rights",
        p: "Under Articles 15-22 GDPR you have the right to: access your data, rectification, erasure, restriction of processing, portability, objection. To exercise these rights write to " + CONTROLLER.email + ".",
      },
      {
        h: "9. Right to complain",
        p: "You have the right to lodge a complaint with the competent supervisory authority. In Germany (North Rhine-Westphalia): Landesbeauftragte für Datenschutz und Informationsfreiheit NRW, https://www.ldi.nrw.de.",
      },
      {
        h: "10. Security",
        p: "Passwords are stored using a hashing algorithm (bcrypt). Traffic between your browser and the site is encrypted (HTTPS). We adopt reasonable technical and organizational measures to protect your data.",
      },
    ],
  },
  de: {
    title: "Datenschutzerklärung",
    sub: "Verarbeitung personenbezogener Daten gemäß DSGVO (EU 2016/679).",
    last_update: "Stand: Februar 2026",
    sections: [
      {
        h: "1. Verantwortlicher",
        p: `${CONTROLLER.name}, ${CONTROLLER.street}, ${CONTROLLER.city} (Deutschland). E-Mail: ${CONTROLLER.email}.`,
      },
      {
        h: "2. Erhobene Daten",
        p: "Bei der Registrierung erheben wir: Vorname, Nachname, E-Mail-Adresse, Wohnort, Passwort (verschlüsselt gespeichert, niemals im Klartext). Wenn du eine Anfrage veröffentlichst oder eine Nachricht sendest, wird der Inhalt in unserer Datenbank gespeichert. Für die Karte geokodieren wir die angegebene Stadt in ungefähre Breitengrade/Längengrade (keine genaue Adresse).",
      },
      {
        h: "3. Zweck der Verarbeitung",
        p: "Die Daten werden ausschließlich verarbeitet, um: (a) Registrierung und Anmeldung zu ermöglichen; (b) hilfesuchende mit hilfsbereiten Personen zu verbinden; (c) E-Mail-Benachrichtigungen über Anfragen, Angebote und Nachrichten zu versenden; (d) Missbrauch zu verhindern (z. B. vorübergehende Sperrung nach vielen fehlgeschlagenen Anmeldeversuchen).",
      },
      {
        h: "4. Rechtsgrundlage",
        p: "Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Erfüllung eines vom Nutzer gewünschten Vertrags/Dienstes) und Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem sicheren Dienst).",
      },
      {
        h: "5. Cookies und ähnliche Technologien",
        p: "Wir verwenden ausschließlich einen technisch erforderlichen Cookie (httpOnly + Secure + SameSite=None), um deine Anmeldesitzung aufrechtzuerhalten. Wir setzen keine Profiling-, Analyse-, Werbe- oder Drittanbieter-Werbe-Cookies ein.",
      },
      {
        h: "6. Drittanbieter",
        p: "Zum Betrieb der Website nutzen wir: Resend (Versand transaktionaler E-Mails, Server in EU/USA mit EU-Standardvertragsklauseln), OpenStreetMap/Nominatim (Kartenanzeige und Stadt-Geokodierung — EU-Server), GoFundMe (externer Link für freiwillige Spenden, wir teilen keine Daten mit ihnen). Wir verwenden kein Google Analytics, kein Facebook Pixel und keine vergleichbaren Tracking-Systeme.",
      },
      {
        h: "7. Speicherdauer",
        p: "Die Daten werden gespeichert, solange dein Konto aktiv ist. Du kannst jederzeit die Löschung deines Kontos per E-Mail anfordern. Daten zu abgeschlossenen Anfragen und Hilfen können in anonymisierter Form (ohne deinen Namen) für die öffentliche Mauer der guten Taten aufbewahrt werden.",
      },
      {
        h: "8. Deine Rechte",
        p: "Gemäß Art. 15-22 DSGVO hast du das Recht auf: Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch. Zur Ausübung dieser Rechte schreibe an " + CONTROLLER.email + ".",
      },
      {
        h: "9. Beschwerderecht",
        p: "Du hast das Recht, dich bei der zuständigen Aufsichtsbehörde zu beschweren. In Nordrhein-Westfalen: Landesbeauftragte für Datenschutz und Informationsfreiheit NRW, https://www.ldi.nrw.de.",
      },
      {
        h: "10. Datensicherheit",
        p: "Passwörter werden mittels Hashing-Algorithmus (bcrypt) gespeichert. Die Verbindung zwischen deinem Browser und der Website ist verschlüsselt (HTTPS). Wir treffen angemessene technische und organisatorische Maßnahmen zum Schutz deiner Daten.",
      },
    ],
  },
  es: {
    title: "Política de privacidad",
    sub: "Tratamiento de datos personales conforme al RGPD (UE 2016/679).",
    last_update: "Última actualización: febrero 2026",
    sections: [
      {
        h: "1. Responsable del tratamiento",
        p: `${CONTROLLER.name}, ${CONTROLLER.street}, ${CONTROLLER.city} (Alemania). Email: ${CONTROLLER.email}.`,
      },
      {
        h: "2. Datos que recogemos",
        p: "Cuando te registras recogemos: nombre, apellido, email, ciudad de residencia, contraseña (almacenada cifrada, nunca en texto claro). Cuando publicas una solicitud o envías un mensaje, el contenido se guarda en nuestra base de datos. Para el mapa, geocodificamos la ciudad indicada en latitud/longitud aproximadas (no una dirección exacta).",
      },
      {
        h: "3. Finalidad del tratamiento",
        p: "Los datos se tratan exclusivamente para: (a) permitir el registro y la autenticación; (b) conectar a las personas que piden ayuda con quienes la ofrecen; (c) enviar notificaciones por email sobre solicitudes, ofertas y mensajes; (d) prevenir abusos (p. ej. bloqueo temporal tras muchos intentos fallidos de inicio de sesión).",
      },
      {
        h: "4. Base jurídica",
        p: "El tratamiento se basa en el art. 6 (1)(b) RGPD (ejecución de un contrato/servicio solicitado por el usuario) y en el art. 6 (1)(f) RGPD (interés legítimo en mantener el servicio seguro).",
      },
      {
        h: "5. Cookies y tecnologías similares",
        p: "Usamos sólo una cookie técnica (httpOnly + Secure + SameSite=None) para mantener tu sesión de acceso. No usamos cookies de perfilado, análisis, publicidad ni de terceros publicitarios.",
      },
      {
        h: "6. Servicios de terceros",
        p: "Para el funcionamiento del sitio usamos: Resend (envío de emails transaccionales, servidores en UE/EE.UU. con cláusulas contractuales estándar de la UE), OpenStreetMap/Nominatim (mapas y geocodificación de ciudades — servidores en UE), GoFundMe (enlace externo para donaciones libres, no compartimos datos con ellos). No usamos Google Analytics, Facebook Pixel ni sistemas similares de seguimiento.",
      },
      {
        h: "7. Conservación de los datos",
        p: "Los datos se conservan mientras tu cuenta esté activa. Puedes solicitar en cualquier momento la eliminación de tu cuenta escribiéndonos por email. Los datos sobre solicitudes y ayudas completadas pueden conservarse de forma anonimizada (sin tu nombre) para el muro público de buenas acciones.",
      },
      {
        h: "8. Tus derechos",
        p: "Conforme a los arts. 15-22 RGPD tienes derecho a: acceso a tus datos, rectificación, supresión, limitación del tratamiento, portabilidad, oposición. Para ejercer estos derechos escríbenos a " + CONTROLLER.email + ".",
      },
      {
        h: "9. Derecho a reclamar",
        p: "Tienes derecho a presentar una reclamación ante la autoridad de control competente. En Alemania (Renania del Norte-Westfalia): Landesbeauftragte für Datenschutz und Informationsfreiheit NRW, https://www.ldi.nrw.de.",
      },
      {
        h: "10. Seguridad",
        p: "Las contraseñas se almacenan con un algoritmo de hashing (bcrypt). El tráfico entre tu navegador y el sitio está cifrado (HTTPS). Adoptamos medidas técnicas y organizativas razonables para proteger tus datos.",
      },
    ],
  },
  fr: {
    title: "Politique de confidentialité",
    sub: "Traitement des données personnelles selon le RGPD (UE 2016/679).",
    last_update: "Dernière mise à jour : février 2026",
    sections: [
      {
        h: "1. Responsable du traitement",
        p: `${CONTROLLER.name}, ${CONTROLLER.street}, ${CONTROLLER.city} (Allemagne). Email : ${CONTROLLER.email}.`,
      },
      {
        h: "2. Données collectées",
        p: "Lors de ton inscription, nous collectons : prénom, nom, email, ville de résidence, mot de passe (stocké chiffré, jamais en clair). Lorsque tu publies une demande ou envoies un message, le contenu est stocké dans notre base de données. Pour la carte, nous géocodons la ville indiquée en latitude/longitude approximatives (pas une adresse précise).",
      },
      {
        h: "3. Finalité du traitement",
        p: "Les données sont traitées uniquement pour : (a) permettre l'inscription et l'authentification ; (b) mettre en relation les personnes qui demandent de l'aide avec celles qui l'offrent ; (c) envoyer des notifications par email sur les demandes, offres et messages ; (d) prévenir les abus (par ex. blocage temporaire après plusieurs tentatives de connexion échouées).",
      },
      {
        h: "4. Base juridique",
        p: "Le traitement repose sur l'art. 6 § 1 b) RGPD (exécution d'un contrat/service demandé par l'utilisateur) et l'art. 6 § 1 f) RGPD (intérêt légitime à maintenir le service sécurisé).",
      },
      {
        h: "5. Cookies et technologies similaires",
        p: "Nous utilisons un seul cookie technique (httpOnly + Secure + SameSite=None) pour maintenir ta session de connexion. Nous n'utilisons ni cookies de profilage, ni d'analyse, ni de publicité, ni de tiers publicitaires.",
      },
      {
        h: "6. Services tiers",
        p: "Pour le fonctionnement du site nous utilisons : Resend (envoi d'emails transactionnels, serveurs en UE/USA avec clauses contractuelles types de l'UE), OpenStreetMap/Nominatim (affichage de cartes et géocodage — serveurs UE), GoFundMe (lien externe pour dons libres, nous ne partageons aucune donnée avec eux). Nous n'utilisons pas Google Analytics, Facebook Pixel ni de systèmes similaires de suivi.",
      },
      {
        h: "7. Conservation des données",
        p: "Les données sont conservées tant que ton compte est actif. Tu peux demander à tout moment la suppression de ton compte en nous écrivant par email. Les données relatives aux demandes et aides accomplies peuvent être conservées sous forme anonymisée (sans ton nom) pour le mur public des bonnes actions.",
      },
      {
        h: "8. Tes droits",
        p: "Selon les articles 15-22 RGPD, tu as le droit : d'accès à tes données, de rectification, d'effacement, de limitation du traitement, de portabilité, d'opposition. Pour exercer ces droits, écris-nous à " + CONTROLLER.email + ".",
      },
      {
        h: "9. Droit de plainte",
        p: "Tu as le droit de déposer une plainte auprès de l'autorité de contrôle compétente. En Allemagne (Rhénanie-du-Nord-Westphalie) : Landesbeauftragte für Datenschutz und Informationsfreiheit NRW, https://www.ldi.nrw.de.",
      },
      {
        h: "10. Sécurité",
        p: "Les mots de passe sont stockés avec un algorithme de hachage (bcrypt). Le trafic entre ton navigateur et le site est chiffré (HTTPS). Nous adoptons des mesures techniques et organisationnelles raisonnables pour protéger tes données.",
      },
    ],
  },
  ja: {
    title: "プライバシーポリシー",
    sub: "GDPR（EU 2016/679）に基づく個人データの処理。",
    last_update: "最終更新：2026年2月",
    sections: [
      {
        h: "1. 管理者",
        p: `${CONTROLLER.name}、${CONTROLLER.street}、${CONTROLLER.city}（ドイツ）。メール：${CONTROLLER.email}。`,
      },
      {
        h: "2. 収集するデータ",
        p: "登録時に、名、姓、メールアドレス、居住都市、パスワード（平文ではなく暗号化して保存）を収集します。依頼の投稿またはメッセージ送信時、その内容は当方のデータベースに保存されます。地図機能では、指定された都市名を大まかな緯度・経度にジオコーディングします（正確な住所ではありません）。",
      },
      {
        h: "3. 処理の目的",
        p: "データは以下の目的のみで処理されます：(a) 登録と認証、(b) 助けを求める人と提供する人の接続、(c) 依頼・オファー・メッセージに関するメール通知の送信、(d) 不正利用の防止（ログイン失敗が多い場合の一時ロックなど）。",
      },
      {
        h: "4. 法的根拠",
        p: "処理は、GDPR 第6条第1項(b)（利用者が要求する契約/サービスの履行）および同(f)（サービスを安全に維持する正当な利益）に基づいています。",
      },
      {
        h: "5. Cookie等の類似技術",
        p: "ログインセッション維持のため、技術的Cookie（httpOnly + Secure + SameSite=None）を1つのみ使用します。プロファイリング、分析、広告、第三者広告Cookieは一切使用しません。",
      },
      {
        h: "6. 第三者サービス",
        p: "サイト運営のため、以下を利用しています：Resend（トランザクションメール送信、EU/米サーバー、EU標準契約条項準拠）、OpenStreetMap/Nominatim（地図表示と都市ジオコーディング、EUサーバー）、GoFundMe（任意の寄付用外部リンク、当方から情報共有はしません）。Google Analytics、Facebook Pixel等の類似トラッキングは使用しません。",
      },
      {
        h: "7. データの保存期間",
        p: "アカウントが有効な間、データを保持します。メールでご連絡いただければ、いつでもアカウントの削除を依頼できます。完了した依頼や助け合いに関するデータは、公開の「善意の壁」のため匿名化された形（氏名なし）で保持される場合があります。",
      },
      {
        h: "8. お客様の権利",
        p: "GDPR 第15条〜第22条に基づき、以下の権利があります：データへのアクセス、訂正、削除、処理の制限、データの可搬性、異議申立て。これらの権利の行使は " + CONTROLLER.email + " までご連絡ください。",
      },
      {
        h: "9. 苦情申立ての権利",
        p: "所轄の監督機関に苦情を申し立てる権利があります。ドイツ（ノルトライン＝ヴェストファーレン州）：Landesbeauftragte für Datenschutz und Informationsfreiheit NRW、https://www.ldi.nrw.de。",
      },
      {
        h: "10. セキュリティ",
        p: "パスワードはハッシュアルゴリズム（bcrypt）で保存されます。ブラウザとサイト間の通信は暗号化されています（HTTPS）。データ保護のため、合理的な技術的・組織的対策を講じています。",
      },
    ],
  },
};

export default function Privacy() {
  const { lang } = useI18n();
  const c = CONTENT[lang] || CONTENT.it;

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-12 md:py-16 anim-fade-up" data-testid="privacy-page">
      <div className="text-xs uppercase tracking-[0.22em] text-mabw-secondary font-semibold mb-2">MABW</div>
      <h1 className="text-3xl md:text-4xl font-semibold leading-tight" style={{ fontFamily: "Outfit" }}>
        {c.title}
      </h1>
      <p className="text-mabw-soft mt-3">{c.sub}</p>
      <p className="text-xs text-mabw-soft mt-2">{c.last_update}</p>

      <div className="mt-10 space-y-6 text-sm md:text-base leading-relaxed">
        {c.sections.map((s, i) => (
          <section key={s.h} className="card-mabw p-6 md:p-8" data-testid={`privacy-section-${i + 1}`}>
            <h2 className="text-lg md:text-xl font-semibold mb-3 text-mabw-text" style={{ fontFamily: "Outfit" }}>{s.h}</h2>
            <p className="text-mabw-soft whitespace-pre-line">{s.p}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
